import { useRef, useState } from "react";

import { SortUpIconComponent, ArrowBottomIconComponent } from "assets/icons";
import { useOutsideClick } from "hooks/useOutsideClick";
import useTranslation from "hooks/useTranslation";
import styles from "./styles.module.scss";

function SortConvsMenu({ sortOrder, setSortOrder }) {
  const [isSortMenuOpen, setIsSortMenuOpen] = useState(false);
  const { getTranslation } = useTranslation(["CHAT", "COMMON"]);
  const { t } = getTranslation();

  const sortingOrderLabel =
    sortOrder === "descending" ? t("NEWEST") : t("OLDEST");

  const ref = useRef();

  useOutsideClick(ref, () => {
    setIsSortMenuOpen(false);
  });

  const handleSetSortOrder = (order) => {
    setSortOrder(order);
    setIsSortMenuOpen(false);
  };

  return (
    <div ref={ref} className={styles.sort_box}>
      <div
        onClick={() => setIsSortMenuOpen(!isSortMenuOpen)}
        className={styles.sort_box__select}
      >
        <SortUpIconComponent
          data-order={sortOrder}
          className={styles.sort_icon}
        />

        <span>{sortingOrderLabel} </span>

        <ArrowBottomIconComponent
          data-menu-open={isSortMenuOpen}
          className={styles.arrow_down}
        />
      </div>
      <div data-show-menu={isSortMenuOpen} className={styles.sort_box__menu}>
        <span onClick={() => handleSetSortOrder("descending")}>
          {t("NEWEST")}
        </span>
        <span onClick={() => handleSetSortOrder("ascending")}>
          {t("OLDEST")}{" "}
        </span>
      </div>
    </div>
  );
}

export default SortConvsMenu;
